// The ONE source of truth for the AdSense publisher ID, imported by the root
// layout (meta tag + loader script) and CookieConsent. Deliberately hardcoded:
// this is a public identifier (visible in every page's HTML and ads.txt), the
// site is a static export with exactly one production identity, and an env
// override only created a second place for the value to drift.
export const ADSENSE_CLIENT_ID = "ca-pub-7385968362698527";
